import AddPage from './AddPage.js'
import { BasePage as CngBasePage, CngHeader } from 'cng-web-lib'
import EditPage from './EditPage.js'
import React from 'react'
import TablePage from './TablePage.js'
import ViewPage from './ViewPage.js'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'
import pathMap from 'src/paths/pathMap'

function WrappedTablePage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <TablePage showNotification={showSnackbar} {...props} />
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

function WrappedAddPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  const labelForInbondList = breadcrumbNameMap.get(pathMap.ABI_INBOND_EVENT_LIST_VIEW)
  const labelForInbondAdd = breadcrumbNameMap.get(pathMap.ABI_INBOND_EVENT_ADD_VIEW)
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <AddPage showNotification={showSnackbar} {...props} />
      )}
      renderHeader={() => (
        <CngHeader
          breadcrumbsConfigurations={[
            { to: pathMap.ABI_INBOND_EVENT_LIST_VIEW, label: labelForInbondList },
            { to: pathMap.ABI_INBOND_EVENT_ADD_VIEW, label: labelForInbondAdd }
          ]}
        />
      )}
    />
  )
}

function WrappedEditPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  const labelForInbondList = breadcrumbNameMap.get(pathMap.ABI_INBOND_EVENT_LIST_VIEW)
  const labelForInbondEdit = breadcrumbNameMap.get(pathMap.ABI_INBOND_EVENT_EDIT_VIEW)
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <EditPage showNotification={showSnackbar} {...props} />
      )}
      renderHeader={() => (
        <CngHeader
          breadcrumbsConfigurations={[
            { to: pathMap.ABI_INBOND_EVENT_LIST_VIEW, label: labelForInbondList },
            { to: pathMap.ABI_INBOND_EVENT_EDIT_VIEW, label: labelForInbondEdit }
          ]}
        />
      )}

      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

function WrappedViewPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  const labelForInbondList = breadcrumbNameMap.get(pathMap.ABI_INBOND_EVENT_LIST_VIEW)
  const labelForInbondView = breadcrumbNameMap.get(pathMap.ABI_INBOND_EVENT_DETAILS_VIEW)
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ViewPage showNotification={showSnackbar} {...props} />
      )}
      renderHeader={() => (
        <CngHeader
          breadcrumbsConfigurations={[
            { to: pathMap.ABI_INBOND_EVENT_LIST_VIEW, label: labelForInbondList },
            { to: pathMap.ABI_INBOND_EVENT_DETAILS_VIEW, label: labelForInbondView }
          ]}
        />
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

export {
  WrappedAddPage as AddPage,
  WrappedEditPage as EditPage,
  WrappedViewPage as ViewPage,
  WrappedTablePage as TablePage
}
